import keys from '@debbie/common/dist/cache/keys.js';
import { CaseTag } from '@debbie/common/dist/cases/index.js';
import { Site } from '@debbie/common/dist/index.js';
import { useMutation } from '@debbie/common/dist/util/hooks.js';
import * as casesLib from '@debbie/cortex/dist/api/cases.js';
import { casesEntity, useCase } from '@debbie/cortex/dist/cases/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import q from '@debbie/cortex/dist/query.js';
import moment from 'moment';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import THEME from '../../theme.js';
import { errorNotification } from '../../utils/errors.js';
import { CaseGroupSelect, Modal } from '..//index.js';
import CaseGroup from '../CaseGroup.js';
import { Col } from '../Grid/index.js';
import EditText from '../Icons/EditText.js';
import TagsEditor from '../TagsEditor.js';
const Header = (props) => {
    const lang = useSelector((s) => s.lang);
    const site = useSelector((s) => s.site);
    const singleCaseLoader = useCase(props.caseId);
    const singleCase = h.hasData(singleCaseLoader) ? singleCaseLoader.data : null;
    const [editingCaseGroup, setEditingCaseGroup] = useState(false);
    const caseGroupMutation = useMutation((caseGroupId) => casesLib.patch(props.caseId, { caseGroupId }), {
        onSuccess: () => {
            q.invalidate(keys.write.modify(casesEntity, props.caseId));
            setEditingCaseGroup(false);
        },
        onError: (err) => errorNotification(lang, err, 'update', lang.errorEntities.case),
    });
    if (!singleCase) {
        return null;
    }
    const updateTags = async (tags) => {
        await casesLib.patch(singleCase.caseId, {
            tags,
        });
        q.invalidate(keys.write.modify(casesEntity, props.caseId));
    };
    return (React.createElement(Col, { width: "12" },
        React.createElement("h3", null,
            React.createElement("small", { "data-tooltip-id": "tooltip-default", "data-tooltip-content": lang.cases.createdAt }, moment(singleCase.createdAt).format(THEME.DATE_FORMAT_LONG)),
            singleCase.caseGroup && (React.createElement(CaseGroup, { caseGroup: singleCase.caseGroup, style: { marginLeft: '10px' } })),
            site === Site.Caseworker && (React.createElement("span", { "data-tooltip-content": singleCase.caseGroup
                    ? lang.caseGroups.editCaseGroup
                    : lang.caseGroups.addCaseGroup, "data-tooltip-id": "tooltip-left" },
                React.createElement(EditCaseGroupIcon, { onClick: () => setEditingCaseGroup(true) }))),
            editingCaseGroup && (React.createElement(Modal, { header: lang.caseGroups.caseGroups, onToggle: () => setEditingCaseGroup(false) },
                React.createElement(CaseGroupSelect, { autofocus: true, value: singleCase.caseGroup?.id ?? null, disabled: caseGroupMutation.isLoading, onChange: (caseGroupId) => caseGroupMutation.mutate(caseGroupId) }))),
            !!singleCase.tags.length && (React.createElement("div", { style: { float: 'right' } },
                React.createElement(TagsEditor, { tags: singleCase.tags, onChange: updateTags, availableTags: [CaseTag.SURVEILLANCE], translations: lang.caseTags }))))));
};
export default Header;
const EditCaseGroupIcon = styled(EditText) `
  width: 16px;
  height: 16px;
  margin: 0.5em 0 0 8px;
  vertical-align: middle;
  cursor: pointer;
`;
//# sourceMappingURL=Header.js.map